module.exports = __webpack_public_path__ + "img/news_3.1f5ad893.png";